/** @jsxRuntime classic */ /** @jsx createElement */ import { createElement } from '@fluentui/react-jsx-runtime';
import { assertSlots } from '@fluentui/react-utilities';
/**
 * Renders a Button component by passing the state defined props to the appropriate slots.
 */ export const renderButton_unstable = (state)=>{
    assertSlots(state);
    const { iconOnly , iconPosition  } = state;
    return /*#__PURE__*/ createElement(state.root, null, iconPosition !== 'after' && state.icon && /*#__PURE__*/ createElement(state.icon, null), !iconOnly && state.root.children, iconPosition === 'after' && state.icon && /*#__PURE__*/ createElement(state.icon, null));
};
